'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./WatermarkWarning.scss');
var warningImg = require('../assets/warning.png');
var warningSignImg = require('../assets/warning-sign.png');

var WatermarkWarning = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WatermarkWarning, _Component);

  function WatermarkWarning() {
    (0, _classCallCheck3.default)(this, WatermarkWarning);
    return (0, _possibleConstructorReturn3.default)(this, (WatermarkWarning.__proto__ || (0, _getPrototypeOf2.default)(WatermarkWarning)).apply(this, arguments));
  }

  (0, _createClass3.default)(WatermarkWarning, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          t = _props.t,
          projectType = _props.projectType;

      var useStaticImg = true;

      return useStaticImg ? _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement('img', { src: warningImg, className: (0, _classnames2.default)(styles.warningAnimation, styles.warningImg), alt: '' })
      ) : _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.warningAnimation, styles.warningContainer, className) },
        _react2.default.createElement(
          'div',
          { className: styles.warnSign },
          _react2.default.createElement('img', { src: warningSignImg, alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.text },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            t('Warning')
          ),
          _react2.default.createElement(
            'div',
            { className: styles.subheader },
            projectType === _projects.projectTypes.video ? t('This video is watermarked') : t('This audio is watermarked')
          ),
          _react2.default.createElement(
            'div',
            { className: styles.hint },
            t('Copying, distribution and making available or communicating to the public is strictly prohibited')
          )
        )
      );
    }
  }]);
  return WatermarkWarning;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  projectType: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = WatermarkWarning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/WatermarkWarning/WatermarkWarning.js
// module id = 830
// module chunks = 1